import React from 'react'
import { createAnimation, IonIcon, IonModal, IonHeader, IonTitle, IonImg, IonContent, IonAvatar } from '@ionic/react'
import { closeOutline } from 'ionicons/icons'
import EditableIonButton from 'components/basepaws/utils/EditableIonButton'

import styles from './AccountCatDetailEdit.module.scss'
import content from 'util/content'

export const Modal = (props) => {
  const { modalState, close, headingText, image, children, headingParam, isContentTrue } = props

  const enterAnimation = (baseEl) => {
    // Flor should improve this!
    const backdropAnimation = createAnimation()
      .addElement(baseEl.querySelector('ion-backdrop'))
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)')

    const wrapperAnimation = createAnimation()
      .addElement(baseEl.querySelector('.modal-wrapper'))
      .keyframes([
        { offset: 0, opacity: '1', transform: 'translateX(100%)' },
        { offset: 1, opacity: '1', transform: 'translateX(0%)' }
      ])

    return createAnimation()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(500)
      .addAnimation([backdropAnimation, wrapperAnimation])
  }

  const leaveAnimation = (baseEl) => {
    return enterAnimation(baseEl).direction('reverse')
  }

  return (
    <IonModal enterAnimation={enterAnimation} leaveAnimation={leaveAnimation} isOpen={modalState} onDidDismiss={close} class={`${styles.modal_right} modal-right`}>
      <IonHeader>
        <div className="d-flex ion-justify-content-between">
          <EditableIonButton
            mode="md"
            fill="clean"
            shape="round"
            color="dark"
            onClick={close}
            className={`${styles.modal_close_button} default_button icon-start`}
          >
            <IonIcon color="dark" icon={closeOutline}/>
            Close
          </EditableIonButton>
          {image &&
            <IonAvatar className="ion-margin-top ion-margin-end">
              <IonImg src={image} alt="Pet avatar image" />
            </IonAvatar>
          }
        </div>
        <IonTitle class="Heading_3 text_sad_purple">
          {isContentTrue
            ? content.get(headingText, { name: headingParam })
            : content.get(headingText)
          }
        </IonTitle>
      </IonHeader>
      <IonContent>
        <div className={`${styles.modal_content} modal-content`}>
          {children}
        </div>
      </IonContent>
    </IonModal>
  )
}
